import { Map } from 'maplibre-gl';

export const SOURCE_ID = 'hm-new-coverageData';

export async function addSource(map: Map) {
  if (map && !map.getSource(SOURCE_ID)) {
    try {
      map.addSource(SOURCE_ID, {
        type: 'vector',
        tiles: [
          'https://segment-coverage.hivemapper.com/segment-coverage/{z}/{x}/{y}.mvt',
        ],
        promoteId: 'id',
      });
    } catch (err) {
      console.log(err);
    }
  }
}
